import { ItemStatus } from '../../../../enums/ItemStatus';
import { ItemType } from '../../../../enums/ItemType';
import { MyRole } from '../../../../enums/MyRole';
import { NodeType } from '../../../../enums/NodeType';
import { Role } from '../../../../enums/Role';
import {
  getInvalidItemDataReference,
  getItemStatusId,
  getSchema
} from '../../../../utils';
import { GetPermissionFn } from '../types';

export const getPushPermission: GetPermissionFn = ({
  isWorkspaceOwner,
  isItemTypePlanner,
  hasRole,
  workspace,
  data,
  empCd
}) => {
  if (!!data?.approvals?.length) {
    return { canView: false, canEdit: false };
  }

  if (hasRole(Role.planningReadonly)) {
    return { canView: false, canEdit: false };
  }

  const isItemTeamManager = data?.myRoles?.some(
    r => r.roleId === MyRole.TeamManager && r.empCd == empCd
  );

  if (!isItemTypePlanner && !isWorkspaceOwner && !isItemTeamManager) {
    return { canView: false, canEdit: false };
  }

  const statusId = getItemStatusId(data);
  if (statusId != ItemStatus.Concept_Review) {
    return { canView: false, canEdit: false };
  }

  const itemSchema = getSchema(workspace.schemas, NodeType.Item);
  if (getInvalidItemDataReference(workspace, itemSchema, data) != null) {
    return { canView: true, canEdit: false };
  }

  return { canView: true, canEdit: true };
};
